import * as React from 'react';
import { FormControl, InputLabel, Select, OutlinedInput, Box, Avatar, MenuItem } from '@mui/material';
import { context } from '../context';

export const AuthorsSelector = () => {

    const { authors, selectedAuthors, setSelectedAuthors } = React.useContext(context);
    
    const onChanged = (e) => {
        setSelectedAuthors(e.target.value);        
    };

    return (
        <FormControl fullWidth size="small">
            <InputLabel 
                id="authors-selector-label"
                sx={{ 
                    fontSize: '0.875rem',
                    '&.Mui-focused': { color: 'primary.main' },
                }}
            >
                直播间
            </InputLabel>
            <Select
                labelId='authors-selector-label'
                id='authors-selector'
                multiple
                value={selectedAuthors}
                onChange={onChanged}
                input={<OutlinedInput label="直播间" />}
                renderValue={selectedAuthors => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        { selectedAuthors.slice(0, 3).map(selectedAuthor => (
                            <Avatar 
                                key={selectedAuthor.id} 
                                src={`//${selectedAuthor.avatar}@60w_60h.webp`}
                                sx={{ 
                                    width: 22, 
                                    height: 22,
                                    border: '1.5px solid',
                                    borderColor: 'background.paper',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                }} 
                            />
                        ))}
                        {selectedAuthors.length > 3 && (
                            <Box sx={{ 
                                width: 22, 
                                height: 22, 
                                borderRadius: '50%',
                                bgcolor: 'grey.100',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '0.625rem',
                                fontWeight: 600,
                                color: 'text.secondary',
                            }}>
                                +{selectedAuthors.length - 3}
                            </Box>
                        )}
                    </Box>
                )}
                sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0, 0, 0, 0.1)',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'primary.light',
                    },
                }}
            >
                { authors.map(author => (
                    <MenuItem 
                        key={author.id} 
                        value={author}
                        sx={{
                            py: 1,
                            px: 1.5,
                            borderRadius: '6px',
                            mx: 0.5,
                            my: 0.25,
                        }}
                    >
                        <Avatar 
                            sx={{ 
                                width: 24, 
                                height: 24, 
                                mr: 1.5,
                                boxShadow: 'none',
                                border: 'none',
                            }} 
                            src={`//${author.avatar}@60w_60h.webp`} 
                        />
                        <Box component="span" sx={{ fontSize: '0.875rem' }}>
                            {author.name}
                        </Box>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}